(function () {
    'use strict';

    angular
        .module('showcaseApp')
        .component('styledSelect', {
            templateUrl: 'app/components/styled-select/styled-select.html',
            controller: styledSelectController,
            bindings: {
                labelKey: '@',
                model: '=',
                name: '@',
                required: '<',
                options: '<',
                valueField: '@',
                labelField: '@',
                placeholder: '@',
                form: '<',
                disabled: '<',
                onFieldChange: '&',
                showErrorsOnSubmit: '<',
                errorMessageKey: '@'
            }
        });

    /** @ngInject */
    function styledSelectController($window, systemConstants, $scope) {
        var $ctrl = this;

        $ctrl.isMobile =
            $window.innerWidth <= systemConstants.BOOTSTRAP_RESOLUTIONS.MIN_SM;

        $ctrl.modalModel = null;

        $ctrl.displayOptions = [];

        $ctrl.$onInit = function () {
            normalizeOptions();
        };

        $ctrl.$onChanges = function () {
            normalizeOptions();
        };

        function normalizeOptions() {
            var displayOptions = [];
            var index = 0;

            if ($ctrl.options === undefined || $ctrl.options === null) {
                $ctrl.displayOptions = [];
                syncFromModel();
                return;
            }

            angular.forEach($ctrl.options, function (item, key) {
                var selfValue = angular.isArray($ctrl.options) ? item : key;
                displayOptions.push({
                    label: resolveField(item, key, selfValue, index, $ctrl.labelField),
                    value: resolveField(item, key, selfValue, index, $ctrl.valueField),
                    original: item,
                    __selected: false
                });
                index++;
            });
            $ctrl.displayOptions = displayOptions;
            syncFromModel();
        }

        function resolveField(item, key, self, index, field) {
            if (field === '$key') {
                return key;
            }
            if (field === '$value') {
                return item;
            }
            if (field === '$self') {
                return self;
            }
            if (field === '$index') {
                return index;
            }
            if (angular.isObject(item) && field) {
                return item[field];
            }
            if (!field) {
                return item;
            }
            return item;
        }

        $ctrl.toggleOption = function (option) {
            var isCurrent =
                $ctrl.modalModel &&
                $ctrl.modalModel.value === option.value;

            $ctrl.displayOptions.forEach(function (opt) {
                opt.__selected = false;
            });

            if (isCurrent) {
                $ctrl.modalModel = null;
            } else {
                option.__selected = true;
                $ctrl.modalModel = option;
            }
        };

        $ctrl.confirmSelection = function () {
            if ($ctrl.modalModel) {
                $ctrl.model = $ctrl.modalModel.value;
            } else {
                $ctrl.model = null;
            }

            if ($ctrl.onFieldChange) {
                $ctrl.onFieldChange();
            }
        };

        function syncFromModel() {
            $ctrl.modalModel = null;

            if (!$ctrl.displayOptions || !$ctrl.displayOptions.length) {
                return;
            }

            $ctrl.displayOptions.forEach(function (opt) {
                opt.__selected = false;
                if (opt.value == $ctrl.model) {
                    $ctrl.modalModel = opt;
                    opt.__selected = true;
                }
            });
        }

        $ctrl.syncFromModel = syncFromModel;

        $ctrl.isInvalid = function() {
            if (!$ctrl.form || !$ctrl.form[$ctrl.name]) {
                return false;
            }
            var field = $ctrl.form[$ctrl.name];
            return (field.$invalid && field.$touched) ||
                ($ctrl.showErrorsOnSubmit && field.$invalid && $ctrl.form.$submitted);
        };

        angular.element($window).on('resize', function () {
            $scope.$apply(function () {
                $ctrl.isMobile =
                    $window.innerWidth < systemConstants.BOOTSTRAP_RESOLUTIONS.MIN_SM;
            });
        });

        $scope.$on('$destroy', function () {
            angular.element($window).off('resize');
        });
    }
})();
